import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'payments';

const updatePaymentById = async (body, paymentId) => {
  const method = 'PUT';
  const url = `${USE_CASE_URL}/${paymentId}`;

  const json = await request({ method, url, body });
  return json;
};

export default updatePaymentById;
